import React from 'react';
import { observer } from 'mobx-react';

// Translations
import translate from '../Translate.js';

// Dependencies
import ReactDataGrid from '@inovua/reactdatagrid-community';
import '@inovua/reactdatagrid-enterprise/base.css'
import '@inovua/reactdatagrid-enterprise/theme/default-light.css'
import Drawer from '../Drawer/Drawer.js';
import moment from 'moment';
import { toggleDrawer } from '../../helpers/helpers.js';

const CheckoutQueue = observer(class CheckoutQueue extends React.Component {
  constructor() {
    super();
    this.renderDisconnectReason = this.renderDisconnectReason.bind(this);
    this.renderCheckoutButton = this.renderCheckoutButton.bind(this);

    this.state = {
      drawerOpen: false,
      selectedSession: ''
    };
  }

  componentDidMount() {
    const { HybridStore } = this.props.store;
    HybridStore.listCheckoutSessions(30, true)
  }

  renderDisconnectReason({data}) {
    switch(data.disconnectReasonId) {
      case 'test-taker-ended':
        return 'Completed successfully';

      case 'proctor-ended':
        return 'Removed from testing session';

      case 'internet-disconnected':
        return 'Internet disconnected';

      default:
        return 'Unknown';
    }
  }

  renderCheckoutButton(data) {
    const { translation } = this.props;
    const sessionSid = data.sid;
    return (
        <span className='data-grid--center'>
          <button
              className='btn'
              onClick={() => {
                toggleDrawer(null, this, 'Checkout');
                this.setState({ selectedSession: sessionSid });
              }}
          >
            {translation.checkout}
          </button>
        </span>
    );
  }

  render() {
    const { translation, store } = this.props;
    const { HybridStore } = store;
    const { drawerOpen, selectedSession } = this.state;

    const gridStyle = { minHeight: 1000 };
    const columns = [
      {
        name: 'appointmentDate',
        header: 'Session Date',
        defaultWidth: 300,
        render: ({data}) => moment(data.appointmentDate).local().tz(moment.tz.guess()).format('M/D/YYYY [at] h:mma z')
      },
      {
        name: 'name',
        header: 'Name',
        type: 'string',
        defaultWidth: 300,
        render: ({ data }) => {
          return <span>{`${data.enrollment.firstName} ${data.enrollment.lastName}`}</span>;
        }
      },
      {
        name: 'disconnectReasonId',
        header: 'End Reason',
        defaultWidth: 300,
        render: (data) => this.renderDisconnectReason(data)
      },
      // {
      //   name: 'sessionLength',
      //   header: 'Duration'
      // },
      {
        name: 'autoFlags',
        header: 'AI Flags',
        render: ({ data }) => {
          return <span className='data-grid--center'>{data.annotationCounts.system}</span>;
        }
      },
      {
        name: 'manualFlags',
        header: 'Proctor Flags',
        render: ({ data }) => {
          return <span className='data-grid--center'>{data.annotationCounts.manual}</span>;
        }
      },
      {
        name: 'checkout',
        header: 'Checkout',
        defaultWidth: 420,
        render: ({ data }) => this.renderCheckoutButton(data)
      },
    ];

    return (
      <main tabIndex="0" id="main-content" className="page">
          <h1>{translation.heading}</h1>

          <ReactDataGrid
            className="reactDataGrid"
            style={gridStyle}
            idProperty="id"
            columns={columns}
            dataSource={HybridStore.checkoutSessions}
            //defaultFilterValue={filterValue}
            //onFilterValueChange={setFilterObject}
            //onSkipChange={setSkip}
            //onLimitChange={setLimit}
            //limit={limit}
            //skip={skip}
            //onRowClick={onRowClick}
            pagination={true}
          />

        {drawerOpen &&
          <Drawer
            content='Checkout'
            large
            isOpen={drawerOpen}
            parent={this}
            sessionSid={selectedSession}
            {...this.props}
          />
        }
      </main>
    )
  }
});

export default translate('CheckoutQueue')(CheckoutQueue);


// WEBPACK FOOTER //
// ./src/app/components/Checkout/CheckoutQueue.js